<template>
  <div class="ProductList">
    <!-- 收藏商品 -->
    <!-- <div
      :class="
        product.productInfoSimpleVo.productSkuSimpleVo.saleStatus == 1 &&
        product.productInfoSimpleVo.productSkuSimpleVo.status == 1
          ? 'product'
          : 'product sellout'
      "
    >
      <div
        v-if="
          product.productInfoSimpleVo.productSkuSimpleVo.saleStatus == 1 &&
          product.productInfoSimpleVo.productSkuSimpleVo.status == 1
        "
      >
        <img
          class="radio"
          @click="
            checked(product.productInfoSimpleVo.productSkuSimpleVo.productSkuId)
          "
          v-if="!checkedArr.productCheck.val"
          :src="icon_check"
        />
        <img
          class="radio"
          @click="
            no_checked(
              product.productInfoSimpleVo.productSkuSimpleVo.productSkuId
            )
          "
          v-if="checkedArr.productCheck.val"
          :src="icon_checked"
        />
      </div>
      <div v-else class="radio radio2">失效</div>
      <img
        class="product_image"
        :src="product.productInfoSimpleVo.productSimpleVo.mainImage || ''"
        @click="
          toDeatil(product.productInfoSimpleVo.productSkuSimpleVo.productSkuId)
        "
      />
      <div
        style="width: 4.75rem; position: relative"
        @click="
          toDeatil(product.productInfoSimpleVo.productSkuSimpleVo.productSkuId)
        "
      >
        <div class="product_name">
          <img
            v-if="getFlag(product.productInfoSimpleVo.productSkuSimpleVo.param)"
            :src="getFlag(product.productInfoSimpleVo.productSkuSimpleVo.param)"
            alt=""
            class="flag-img"
          />
          {{ product.productInfoSimpleVo.productSkuSimpleVo.title }}
        </div>
        <div class="product_des">
          {{ product.productInfoSimpleVo.productSimpleVo.brandName }} |
          {{ product.productInfoSimpleVo.productSkuSimpleVo.description }}
        </div>
        <div class="spec">
          <template v-if="product.productInfoSimpleVo.productSkuSimpleVo.spec1"
            >年份:</template
          >{{ product.productInfoSimpleVo.productSkuSimpleVo.spec1 }}
          <template v-if="product.productInfoSimpleVo.productSkuSimpleVo.spec2"
            >| 容量:</template
          >
          {{ product.productInfoSimpleVo.productSkuSimpleVo.spec2 }}
          <template v-if="product.productInfoSimpleVo.productSkuSimpleVo.spec3"
            >| 单位:</template
          >
          {{ product.productInfoSimpleVo.productSkuSimpleVo.spec3 }}
        </div>
        <div class="del" @click.stop="del(product.id)">
          <img :src="icon_del" />
        </div>
        <div class="product_money">
          <product-type-tag
            :type="product.productInfoSimpleVo.productSkuSimpleVo.type"
            class="type-tag"
            v-if="product.productInfoSimpleVo.productSkuSimpleVo.type !== 3"
          ></product-type-tag>
          <div
            v-if="product.productInfoSimpleVo.productSkuSimpleVo.type != '2'"
            class="product_type"
            style="font-weight: bold"
          >
            <span class="currency">CNY</span>
            {{
              formatPrice(product.productInfoSimpleVo.productSkuSimpleVo.price)
            }}
          </div>
          <div v-else>
            <div class="product_type" style="font-weight: bold; line-height: 1">
              <span class="currency">HKD</span>
              {{
                formatPrice(
                  product.productInfoSimpleVo.productSkuSimpleVo.priceHkd
                )
              }}
            </div>
            <div style="font-size: 20rpx; color: #ba1622; line-height: 1">
              <span class="currency">≈CNY</span>
              {{
                formatPrice(
                  product.productInfoSimpleVo.productSkuSimpleVo.price
                )
              }}
            </div>
          </div>
        </div>
        <img class="product-arrow" :src="order_arrow" />
      </div>
    </div> -->
    <product-card
      class="product-item"
      :class="{
        sellout:
          product.productInfoSimpleVo.productInfo.saleStatus !== 1 ||
          product.productInfoSimpleVo.productInfo.status !== 1,
      }"
      :product="product.productInfoSimpleVo"
      hide-quantity
      show-arrow
      :isImageToDetail="false"
      :hide-price="
        product.productInfoSimpleVo.productInfo.saleStatus == 1 &&
        product.productInfoSimpleVo.productInfo.status == 1
          ? false
          : true
      "
    >
      <div slot="before" class="checkbox-wrap">
        <template
          v-if="
            product.productInfoSimpleVo.productInfo.saleStatus == 1 &&
            product.productInfoSimpleVo.productInfo.status == 1
          "
        >
          <img
            class="radio"
            @click="checked(product.productInfoSimpleVo.productSkuId)"
            v-if="!checkedArr.productCheck.val"
            :src="icon_check"
          />
          <img
            class="radio"
            @click="no_checked(product.productInfoSimpleVo.productSkuId)"
            v-if="checkedArr.productCheck.val"
            :src="icon_checked"
          />
        </template>
        <!-- 失效 -->
        <div v-else class="radio radio2">失效</div>
      </div>
      <div slot="quantity" class="quantity">
        <button class="delete-btn" @click.stop="del(product.id)">
          <img
            class="delete-btn-img"
            src="@/assets/images/icon-delete.png"
            mode="aspectFit"
          />
        </button>
      </div>
    </product-card>
    <!-- 展开相似酒款 -->
    <div
      v-if="product.likeProductSimpleVoList.length > 0"
      :class="showLike ? 'showLike on' : 'showLike'"
      @click="showLike_click"
    >
      <div>相似酒款</div>
      <img :src="order_arrow" />
    </div>
    <!-- 相似酒款商品 -->
    <div v-if="showLike" class="likeProductList">
      <!-- <div
        v-for="(likeItem, likeIndex) in product.likeProductSimpleVoList"
        :key="likeItem.productSkuSimpleVo.productSkuId"
      >
        <div
          :class="[
            likeIndex < product.likeProductSimpleVoList.length - 1
              ? 'product border'
              : 'product',
            likeItem.productSkuSimpleVo.saleStatus == 1 &&
            likeItem.productSkuSimpleVo.status == 1
              ? ''
              : 'sellout',
          ]"
          v-if="
            likeItem.productSkuSimpleVo.saleStatus == 1 &&
            likeItem.productSkuSimpleVo.status == 1
          "
        >
          <div
            v-if="
              likeItem.productSkuSimpleVo.saleStatus == 1 &&
              likeItem.productSkuSimpleVo.status == 1
            "
          >
            <img
              class="radio"
              @click="likeChecked(likeItem.productSkuSimpleVo.productSkuId)"
              v-if="!checkedArr.likeArr[likeIndex].val"
              :src="icon_check"
            />
            <img
              class="radio"
              @click="like_no_checked(likeItem.productSkuSimpleVo.productSkuId)"
              v-if="checkedArr.likeArr[likeIndex].val"
              :src="icon_checked"
            />
          </div>
          <div v-else class="radio radio2">失效</div>
          <img
            class="product_image"
            :src="likeItem.productSimpleVo.mainImage || ''"
            @click="toDeatil(likeItem.productSkuSimpleVo.productSkuId)"
          />
          <div
            style="width: 4.75rem"
            @click="toDeatil(likeItem.productSkuSimpleVo.productSkuId)"
          >
            <div class="product_name">
              <img
                v-if="getFlag(likeItem.productSkuSimpleVo.param)"
                :src="getFlag(likeItem.productSkuSimpleVo.param)"
                alt=""
                class="flag-img"
              />
              {{ likeItem.productSkuSimpleVo.title }}
            </div>
            <div class="product_des">
              {{ likeItem.productSimpleVo.brandName }} |
              {{ product.productInfoSimpleVo.productSkuSimpleVo.description }}
            </div>
            <div class="spec">
              <template v-if="likeItem.productSkuSimpleVo.spec1">年份:</template
              >{{ likeItem.productSkuSimpleVo.spec1 }}
              <template v-if="likeItem.productSkuSimpleVo.spec2"
                >| 容量:</template
              >
              {{ likeItem.productSkuSimpleVo.spec2 }}
              <template v-if="likeItem.productSkuSimpleVo.spec3"
                >| 单位:</template
              >
              {{ likeItem.productSkuSimpleVo.spec3 }} 年份:
              {{ likeItem.productSkuSimpleVo.spec1 }} | 容量:
              {{ likeItem.productSkuSimpleVo.spec2 }} | 单位:
              {{ likeItem.productSkuSimpleVo.spec3 }}
            </div>
            <div class="product_money">
              <product-type-tag
                :type="likeItem.productSkuSimpleVo.type"
                class="type-tag"
                v-if="likeItem.productSkuSimpleVo.type !== 3"
              ></product-type-tag>
              <div
                v-if="likeItem.productSkuSimpleVo.type != '2'"
                class="product_type"
                style="font-weight: bold"
              >
                <span class="currency">CNY</span>
                {{ formatPrice(likeItem.productSkuSimpleVo.price) }}
              </div>
              <div v-else>
                <div
                  class="product_type"
                  style="font-weight: bold; line-height: 1"
                >
                  <span class="currency">HKD</span>
                  {{ formatPrice(likeItem.productSkuSimpleVo.priceHkd) }}
                </div>
                <div style="font-size: 20rpx; color: #ba1622; line-height: 1">
                  <span class="currency">≈CNY</span>
                  {{ formatPrice(likeItem.productSkuSimpleVo.price) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <product-card
        v-for="(lItem, lIndex) in product.likeProductSimpleVoList"
        :key="lItem.id"
        class="product-item"
        :class="{
          sellout:
            lItem.productInfo.saleStatus !== 1 ||
            lItem.productInfo.status !== 1,
        }"
        :product="lItem"
        hide-quantity
        show-arrow
        :isImageToDetail="false"
      >
        <div slot="before" class="checkbox-wrap">
          <template
            v-if="
              lItem.productInfo.saleStatus == 1 && lItem.productInfo.status == 1
            "
          >
            <img
              class="radio"
              @click="likeChecked(lItem.productSkuId)"
              v-if="!checkedArr.likeArr[lIndex].val"
              :src="icon_check"
            />
            <img
              class="radio"
              @click="like_no_checked(lItem.productSkuId)"
              v-if="checkedArr.likeArr[lIndex].val"
              :src="icon_checked"
            />
          </template>
          <!-- 失效 -->
          <div v-else class="radio radio2">失效</div>
        </div>
      </product-card>
    </div>
    <!-- 收回相似酒款 -->
    <div :class="showLike ? 'HideLike on' : 'HideLike'" @click="hideLike">
      <img :src="order_arrow" />
    </div>
  </div>
</template>

<script>
  import icon_check from '@/assets/images/my/icon_check.png'
  import icon_checked from '@/assets/images/my/icon_checked.png'
  import icon_del from '@/assets/images/my/icon_del.png'
  import order_arrow from '@/assets/images/my/order_arrow.png'
  // import ProductTypeTag from "@/components/ProductTypeTag";
  import ProductCard from "@/components/ProductCard";
  export default {
    props: {
      product: Object,
      checkedArr: Object
    },
    components: {
      // ProductTypeTag,
      ProductCard
    },
    name: "ProductInfo",
    data () {
      return {
        // checked: false,
        showLike: false
      }
    },
    computed: {
      icon_check () {
        return icon_check
      },
      icon_checked () {
        return icon_checked
      },
      icon_del () {
        return icon_del
      },
      order_arrow () {
        return order_arrow
      }
    },
    methods: {
      // typeTo (val) {
      //     let str = '';
      //     switch (val) {
      //     case 1:
      //         str = '跨境配送'
      //         break;
      //     case 2:
      //         str = '香港自提'
      //         break;
      //     case 3:
      //         str = '境内商品'
      //         break;
      //     default:
      //         str = ''
      //     }
      //     return str
      // },
      formatPrice (num) {
        let num1 = Number(num)
        num1 = num1.toFixed(2);
        let str = num1.toString().split(".")[1]
        let arr = Math.floor(num1).toString().split("").reverse();
        let res = [];
        for (let i = 0; i < arr.length; i++) {
          if (i % 3 === 0 && i !== 0) {
            res.push(",");
          }
          res.push(arr[i]);
        }
        res = res.reverse().join("");
        return res + "." + str;
      },
      checked (e) {
        this.$emit('fatherMethod', { id: e, val: true }, 'onMyEvent');
      },
      likeChecked (e) {
        this.$emit('fatherMethod', { id: e, val: true }, 'onMyEvent2');
      },
      no_checked (e) {
        this.$emit('fatherMethod', { id: e, val: false }, 'onMyEvent');
      },
      like_no_checked (e) {
        this.$emit('fatherMethod', { id: e, val: false }, 'onMyEvent2');
      },
      del (e) {
        console.log(e)
        this.$emit('fatherMethod', { id: e }, 'del_event');
      },
      showLike_click () {
        this.showLike = true
      },
      hideLike () {
        this.showLike = false
      },
      toDeatil (e) {
        let productSkuId = e
        if (productSkuId) {
          this.$router.push({
            path: "/productDetail",
            query: {
              productSkuId: productSkuId
            }
          })
        }
      },
      getFlag (param) {
        var icon = ''
        if (!param || !Array.isArray(param)) {
          return ''
        }
        param.forEach((item) => {
          if (item.key === '国家') {
            icon = (item && item.icon) || ''
          }
        })
        return icon
      }
    }
  }
</script>

<style lang="scss" scoped>
  /* component/product_info/product_info.wxss */
  .flag-img {
    width: 0.26rem;
    height: 0.22rem;
    margin-top: 0.08rem;
    margin-right: 0.08rem;
    vertical-align: top;
  }
  .product {
    width: 7.1rem;
    margin: auto;
    margin-top: 0.2rem;
    background: #fff;
    border-radius: 0.06rem;
    min-height: 2.2rem;
    display: flex;
    padding: 0.2rem;
    box-sizing: border-box;
    align-items: center;
    position: relative;
  }
  .product_image {
    width: 1.8rem;
    height: 1.8rem;
    margin-left: 0.4rem;
  }
  .product_name {
    font-size: 0.26rem;
    color: #060606;
    font-weight: bold;
    // margin-bottom:0.06rem;
    height: 0.4rem;
  }
  .product_des {
    // font-size: 0.22rem;
    // color: #060606;
    // line-height: 0.28rem;
    // margin-bottom: 0.08rem;
    font-size: 0.24rem;
    line-height: 0.36rem;
    height: 0.72rem;
    color: #060606;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .product_type {
    margin-left: 0.15rem;
    font-size: 0.26rem;
  }
  /* .sellout{
                  width: 90rpx;
                  height: 90rpx;
                  position: absolute;
                  top: 0;
                  left: 0;
                } */

  .checkbox-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .radio {
    width: 0.39rem;
    height: 0.39rem;
    // position: absolute;
    // left: 0.2rem;
    // top: 50%;
    // transform: translateY(-50%);
  }
  .radio2 {
    width: 0.65rem;
    height: 0.39rem;
    font-size: 0.24rem;
    color: #fff;
    display: flex;
    border-radius: 0.39rem;
    align-items: center;
    justify-content: center;
    background: #c6c6c6;
    // left: 0.1rem;
    position: static;
    transform: translateY(0);
  }
  .showLike {
    width: 6.8rem;
    height: 0.62rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 0.01rem solid #eaeaea;
    font-size: 0.22rem;
    color: #ba1621;
    font-weight: bold;
    margin: auto;
  }
  .showLike.on img {
    display: none;
  }
  .showLike.on div {
    height: auto;
  }
  .showLike.on {
    justify-content: space-between;
    height: 0.7rem;
    padding: 0.18rem 0.1rem;
    box-sizing: border-box;
    line-height: 0.7rem;
  }
  .showLike img {
    width: 0.11rem;
    height: 0.19rem;
    transform: rotate(90deg);
    margin-left: 0.14rem;
  }
  .ProductList {
    width: 7.1rem;
    margin: auto;
    margin-top: 0.2rem;
    background: #fff;
    border-radius: 0.06rem;
  }
  .spec {
    font-size: 0.22rem;
    color: #6a6a6a;
    height: 0.45rem;
  }
  .product_money {
    display: flex;
    font-size: 0.24rem;
    color: #ba1622;
    align-items: center;
    // margin-top: 0.1rem;
    height: 0.5rem;
  }
  .likeProductList .product {
    margin-top: 0;
  }
  .likeProductList .product.border {
    border-bottom: 0.01rem solid #eaeaea;
  }
  .HideLike {
    display: none;
    width: 6.8rem;
    height: 0.62rem;
    justify-content: center;
    align-items: center;
    border-top: 0.01rem solid #eaeaea;
    margin: auto;
  }
  .HideLike.on {
    display: flex;
  }
  .HideLike img {
    width: 0.11rem;
    height: 0.19rem;
    transform: rotate(-90deg);
  }

  .sellout {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    // opacity: 0.7;
  }
  .sellout .custom-right-class,
  .sellout .custom-image-class {
    opacity: 0.7;
  }
  .del {
    position: absolute;
    right: 0;
    top: 1.6rem;
    z-index: 2;
  }
  .del img {
    width: 0.3rem;
    height: 0.37rem;
  }
  .delete-btn {
    width: 0.4rem;
    height: 0.46rem;
    background: transparent;
    text-align: center;
    margin-left: 0.26rem;
  }
  .delete-btn img {
    width: 0.3rem;
    height: 0.45rem;
    object-fit: contain;
  }
  .product-item {
    margin: 0 !important;
  }
</style>
